// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const GeneralDecimalFormat = t.struct({
    allowedDecimalFormats: t.Array,
    key: t.String,
    value: t.String
}, {
    name: 'GeneralDecimalFormat',
    strict: true
});

export const getDefaultState = () => new GeneralDecimalFormat({
    allowedDecimalFormats: [],
    key: '',
    value: ''
});

export default GeneralDecimalFormat;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/general-decimal-format.js